import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedicalProcedure = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "medicalProcedure",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12453",
			"data-name": "Path 12453",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12454",
			"data-name": "Path 12454",
			d: "M21.268,11.732a2.5,2.5,0,1,1-3.536,0,2.5,2.5,0,0,1,3.536,0",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12455",
			"data-name": "Path 12455",
			d: "M6,3H4A2,2,0,0,0,2,5V9A6,6,0,0,0,14,9V5a2,2,0,0,0-2-2H10",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12456",
			"data-name": "Path 12456",
			d: "M19.5,16v.25a5.75,5.75,0,0,1-11.5,0V15",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12457",
			"data-name": "Path 12457",
			d: "M6,2V4",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12458",
			"data-name": "Path 12458",
			d: "M10,2V4",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgMedicalProcedure;
